import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  base: '/dg3/',
  mode: 'history',
  routes: [
    { path: '/room/:id', name: 'room', component: () => import('@/pages/index') },
    { path: '/coupons', name: 'coupons', component: () => import('@/pages/coupons') },
    { path: '/coupon/:id', name: 'coupon', component: () => import('@/pages/coupon') },
    { path: '/coupon-product/:id', name: 'coupon', component: () => import('@/pages/coupon-product') },
    { path: '/verification/:data', name: 'verification', component: () => import('@/pages/verification') },
    { path: '/poster', name: 'poster', component: () => import('@/pages/poster') },
  ]
})
